import { pathOr } from 'ramda';

import { IFeaturesMap } from '../../../common/types/map';
import { IApplicationState } from '../../../common/types/redux';
import { selectMapBounds } from '../mapBounds';

// стабильная ссылка: новый объект на каждый вызов заставлял подписчиков
// ре-рендериться на каждый диспатч, даже когда фич нет
const EMPTY_FEATURES_MAP: IFeaturesMap = {};

export const selectFeaturesForPrecision = (state: IApplicationState) => {
  const { precision } = selectMapBounds(state);

  return pathOr<IFeaturesMap>(EMPTY_FEATURES_MAP, [precision, 'features'], state.map.features);
};
